import BaseEntity            from '@/core/misc/BaseEntity';
import Title_ru_RU from '@/core/misc/decorators/Title_ru_RU';
import TYPES       from '@/core/services/Changelogs/types';
import Title_ru_RU_Class     from "@/core/misc/decorators/Title_ru_RU_Class";
import QtyMultiplier from "@/core/types/QtyMultiplier";
import Core from "@/core/Core";

@Title_ru_RU_Class('Единица измерения')             // unit → Unit
class Unit extends BaseEntity {

  static Events = {
    Created: 'unit:created',
    Updated: 'unit:updated',
    Deleted: 'unit:deleted',
  } as const;

  /** Краткое наименование: кг */
  @Title_ru_RU('Название', TYPES.STRING)
  public name: string;

  /** Полное наименование: килограмм */
  @Title_ru_RU('Полное название', TYPES.STRING)
  public nameFull: string;

  /** Код по ОКЕИ */
  @Title_ru_RU('Код', TYPES.STRING)
  public code: string;

  /** Множитель количества (напр. в 1 декалитре — 10) */
  @Title_ru_RU('Множитель', TYPES.NUMBER)
  public qtyMultiplier: QtyMultiplier = new QtyMultiplier(1);

  toString() {
    return this.name;
  }

  static fromServer(data: any, result = new Unit()): Unit {
    super.fromServer(data, result);

    result.name = data.name;
    result.nameFull = data.nameFull;
    result.code = data.code;
    result.qtyMultiplier = Core.utils.hydrate(data.qtyMultiplier, QtyMultiplier.fromServer)!;

    return result;
  }

  /** шт. часто нужна по умолчанию, поэтому целесообразно иметь метод */
  static initDefault(): Unit {
    return Unit.fromServer({
      id:            1,
      version:       1,
      isDeleted:     false,
      code:          '796',
      name:          'шт',
      nameFull:      'Штука',
      qtyMultiplier: '1',
    });
  }
}

export default Unit;